import { render, staticRenderFns } from "./diyReportFieldDetail.vue?vue&type=template&id=36d1159a&scoped=true"
import script from "./diyReportFieldDetail.vue?vue&type=script&lang=js"
export * from "./diyReportFieldDetail.vue?vue&type=script&lang=js"
import style0 from "./diyReportFieldDetail.vue?vue&type=style&index=0&id=36d1159a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1159a",
  null
  
)

export default component.exports